/* Purposeful motion. Only native scrolling; frames stop when values settle. */
(() => {
  'use strict';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const clamp = (n, a = 0, b = 1) => Math.max(a, Math.min(b, n));
  const range = (p, start, end) => clamp((p - start) / (end - start));
  const smooth = p => p * p * (3 - 2 * p);
  const $ = (root, sel) => root.querySelector(sel);
  const $$ = (root, sel) => [...root.querySelectorAll(sel)];
  const animated = new Set();
  let frame = 0;
  function wake() { if (!frame) frame = requestAnimationFrame(tick); }
  function tick() {
    frame = 0;
    let unsettled = false;
    animated.forEach(scene => { if (scene.visible) unsettled = scene.update() || unsettled; });
    if (unsettled) wake();
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { const scene = entry.target.jScene; if (scene) scene.visible = entry.isIntersecting; });
    wake();
  }, {rootMargin:'100px'}) : null;
  function register(scene) {
    animated.add(scene); scene.el.jScene = scene; scene.visible = !observer;
    if (observer) observer.observe(scene.el);
    wake();
  }
  function settle(scene, target) {
    scene.p = reduce.matches ? target : scene.p + (target - scene.p) * .14;
    if (Math.abs(scene.p - target) < .0008) scene.p = target;
    return scene.p !== target;
  }
  function transform(el, value) { if (el) el.setAttribute('transform', value); }
  function opacity(el, value) { if (el) el.style.opacity = clamp(value).toFixed(3); }

  class Cinema {
    constructor(el) {
      this.el = el; this.p = 0; this.stage = -1; this.manual = null;
      this.parts = {};
      ['tank','weight','pressure','water-label','weight-label','clock','clock-ring','clock-hand'].forEach(k => {this.parts[k] = $(el, `[data-aging-${k}]`);});
      this.panels = $$(el,'[data-cinema-panel]'); this.buttons = $$(el,'[data-cinema-step]');
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.manual = Number(button.dataset.cinemaStep) / 3; this.manualY = scrollY; wake();
      }));
      $(el,'.j-cinema__controls').hidden = false;
      el.classList.add('is-ready');
      this.draw(0); register(this);
    }
    update() {
      const rect = this.el.getBoundingClientRect();
      const stage = $(this.el,'.j-cinema__stage');
      const scrollScene = !reduce.matches && getComputedStyle(stage).position === 'sticky';
      let target = scrollScene ? clamp(-rect.top / Math.max(1, this.el.offsetHeight - stage.offsetHeight)) : 0;
      if (this.manual !== null) {
        if (scrollScene && Math.abs(scrollY - this.manualY) > 80) this.manual = null;
        else target = this.manual;
      }
      const moving = settle(this,target); this.draw(this.p);
      $(this.el,'.j-cinema__scroll-hint').hidden = !scrollScene;
      return moving;
    }
    draw(p) {
      const a = this.parts;
      const weight = smooth(range(p,.35,.59));
      const finish = smooth(range(p,.74,1));
      // The original engraving stays intact; only its illustrated layers move.
      transform(a.tank,`translate(${-12*finish} ${-8*finish}) scale(${1+.016*finish})`);
      transform(a.weight,`translate(0 ${130*weight})`);
      opacity(a.pressure,range(p,.5,.62)*(1-finish));
      opacity(a['water-label'],range(p,.13,.29)*(1-range(p,.38,.51)));
      opacity(a['weight-label'],range(p,.45,.6)*(1-finish));
      opacity(a.clock,range(p,.4,.53));
      a['clock-ring'].style.strokeDashoffset = String(100*(1-range(p,.4,.8)));
      transform(a['clock-hand'],`rotate(${range(p,.4,.82)*690} 1300 105)`);
      this.el.style.setProperty('--cinema-progress',Math.max(.015,p));
      const stage = Math.min(3,Math.floor(p*3+.32));
      if (stage !== this.stage) {
        this.stage = stage; this.el.dataset.stage = stage;
        this.panels.forEach((panel,i) => { panel.hidden = i !== stage; });
        this.buttons.forEach((button,i) => button.setAttribute('aria-pressed',String(i===stage)));
      }
    }
  }
  class Parcel {
    constructor(el) {
      this.el=el; this.p=0; this.manual=null;
      this.parts={}; ['lid','cold','box-clip'].forEach(k => {this.parts[k]=$(el,`[data-parcel-${k}]`);});
      this.button=$(el,'.j-parcel-scene__footer button'); this.label=$(el,'[data-parcel-label]');
      this.button.hidden=false;
      this.button.addEventListener('click', () => {this.manual=this.p>.5 ? 0 : 1; wake();});
      el.classList.add('is-ready'); register(this);
    }
    update() {
      const r=this.el.getBoundingClientRect();
      let target=reduce.matches ? 1 : smooth(clamp((innerHeight-r.top)/(innerHeight*.7)));
      if(this.manual!==null) target=this.manual;
      const moving=settle(this,target); const p=this.p;
      transform(this.parts.lid,`translate(0 ${450*(1-p)})`);
      transform(this.parts.cold,`translate(0 ${280*(1-p)})`);
      opacity(this.parts.cold,range(p,.1,.45));
      this.parts['box-clip'].setAttribute('d',`M0 ${590-30*p}L${835+112*p} ${495-30*p}L1254 ${640-55*p}V1254H0Z`);
      const open=p>.5; this.button.setAttribute('aria-pressed',String(open));
      this.label.textContent=open ? 'Paket schließen' : 'Paket öffnen';
      this.el.dataset.open=open; return moving;
    }
  }
  function pointerDepth(el, kind) {
    if(el.dataset.depthReady) return; el.dataset.depthReady='true';
    let x=0,y=0,tx=0,ty=0,raf=0;
    function paint() {
      raf=0; x+=(tx-x)*.12; y+=(ty-y)*.12;
      if(kind==='catalog') {el.style.setProperty('--catalog-x',`${x*15}px`);el.style.setProperty('--catalog-y',`${y*12}px`);el.style.setProperty('--catalog-angle',`${x*5}deg`);}
      else {el.style.setProperty('--card-rx',`${-y*4}deg`);el.style.setProperty('--card-ry',`${x*4}deg`);}
      if(Math.abs(tx-x)+Math.abs(ty-y)>.002) raf=requestAnimationFrame(paint);
    }
    el.addEventListener('pointermove',e=>{if(!fine.matches||reduce.matches)return;const r=el.getBoundingClientRect();tx=(e.clientX-r.left)/r.width*2-1;ty=(e.clientY-r.top)/r.height*2-1;if(!raf)raf=requestAnimationFrame(paint);});
    el.addEventListener('pointerleave',()=>{tx=ty=0;if(!raf)raf=requestAnimationFrame(paint);});
  }
  function loupe(img) {
    const host=img.closest('modal-opener') || img.parentElement;
    if(host.dataset.loupeReady || !host.querySelector('.product__media')) return;
    host.dataset.loupeReady='true'; host.classList.add('j-loupe-host');
    const lens=document.createElement('span'); lens.className='j-loupe'; lens.setAttribute('aria-hidden','true');
    const button=document.createElement('button');button.type='button';button.className='j-loupe-toggle';button.textContent='Detail-Lupe';button.setAttribute('aria-label','Detail-Lupe ein- oder ausschalten; mit Finger oder Pfeiltasten bewegen');button.setAttribute('aria-pressed','false');
    host.append(lens,button);
    let enabled=false,hover=false,x=.5,y=.5,raf=0,drag=null;
    function paint() {
      raf=0;
      const r=img.getBoundingClientRect(),h=host.getBoundingClientRect();
      if(!r.width||!img.naturalWidth) return;
      const d=lens.offsetWidth, fit=getComputedStyle(img).objectFit;
      const factor=(fit==='contain'?Math.min:Math.max)(r.width/img.naturalWidth,r.height/img.naturalHeight);
      const iw=img.naturalWidth*factor,ih=img.naturalHeight*factor;
      const cx=clamp(x*r.width,d/2,Math.max(d/2,r.width-d/2)),cy=clamp(y*r.height,d/2,Math.max(d/2,r.height-d/2));
      lens.style.left=`${r.left-h.left+cx-d/2}px`;lens.style.top=`${r.top-h.top+cy-d/2}px`;
      lens.style.backgroundImage=`url("${img.currentSrc||img.src}")`;
      lens.style.backgroundSize=`${iw*2}px ${ih*2}px`;
      lens.style.backgroundPosition=`${d/2-(cx-(r.width-iw)/2)*2}px ${d/2-(cy-(r.height-ih)/2)*2}px`;
      lens.classList.toggle('is-visible',enabled||hover);
      lens.classList.toggle('is-draggable',enabled);
      button.textContent=enabled ? 'Lupe ziehen · schließen' : 'Detail-Lupe';
    }
    function queue(){if(!raf)raf=requestAnimationFrame(paint);}
    button.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();enabled=!enabled;button.setAttribute('aria-pressed',String(enabled));hover=false;queue();});
    host.addEventListener('pointermove',e=>{if(drag||e.target===button||enabled)return;if(!enabled&&(!fine.matches||e.pointerType==='touch'))return;hover=fine.matches&&e.pointerType!=='touch';const r=img.getBoundingClientRect();x=clamp((e.clientX-r.left)/r.width);y=clamp((e.clientY-r.top)/r.height);queue();});
    // Capture only a drag started on the active lens. The surrounding image still scrolls/swipes.
    lens.addEventListener('pointerdown',e=>{
      if(!enabled||e.button>0)return;
      e.preventDefault();e.stopPropagation();
      const r=img.getBoundingClientRect(),l=lens.getBoundingClientRect();
      drag={id:e.pointerId,cx:e.clientX,cy:e.clientY,x:(l.left+l.width/2-r.left)/r.width,y:(l.top+l.height/2-r.top)/r.height};
      lens.setPointerCapture(e.pointerId);lens.classList.add('is-dragging');
    });
    lens.addEventListener('pointermove',e=>{
      if(!drag||drag.id!==e.pointerId)return;
      e.preventDefault();e.stopPropagation();const r=img.getBoundingClientRect();
      x=clamp(drag.x+(e.clientX-drag.cx)/r.width);y=clamp(drag.y+(e.clientY-drag.cy)/r.height);queue();
    });
    function endDrag(e){
      if(!drag||drag.id!==e.pointerId)return;
      drag=null;lens.classList.remove('is-dragging');
      if(lens.hasPointerCapture(e.pointerId))lens.releasePointerCapture(e.pointerId);
    }
    lens.addEventListener('pointerup',endDrag);lens.addEventListener('pointercancel',endDrag);
    lens.addEventListener('lostpointercapture',()=>{drag=null;lens.classList.remove('is-dragging');});
    lens.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();});
    host.addEventListener('pointerleave',()=>{hover=false;queue();});
    button.addEventListener('keydown',e=>{
      if(e.key==='Escape'){enabled=false;hover=false;button.setAttribute('aria-pressed','false');queue();return;}
      if(!enabled||!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key))return;
      e.preventDefault();x=clamp(x+(e.key==='ArrowLeft'?-.1:e.key==='ArrowRight'?.1:0));y=clamp(y+(e.key==='ArrowUp'?-.1:e.key==='ArrowDown'?.1:0));queue();
    });
    img.addEventListener('load',queue);addEventListener('resize',queue,{passive:true});
  }
  const cardObserver='IntersectionObserver' in window ? new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    if(!reduce.matches){entry.target.classList.add('is-entering');setTimeout(()=>entry.target.classList.remove('is-entering'),1400);}
    cardObserver.unobserve(entry.target);
  }),{threshold:.12}) : null;
  function init(root=document) {
    $$(root,'j-aging-cinema:not(.is-ready)').forEach(el=>new Cinema(el));
    $$(root,'j-parcel-scene:not(.is-ready)').forEach(el=>new Parcel(el));
    $$(root,'[data-motion-catalog]').forEach(el=>pointerDepth(el,'catalog'));
    $$(root,'.j-card:not([data-depth-ready])').forEach((el,i)=>{pointerDepth(el,'card');el.style.setProperty('--entry-delay',`${i%4*70}ms`);if(cardObserver)cardObserver.observe(el);});
    $$(root,'.j-product:not(.r-pdp-shell--voucher):not(#premium-buchen) .product__media-item:not(.j-gallery-support) .product__media img').forEach(loupe);
    const hero=$(root,'[data-motion-hero]');
    if(hero&&!hero.jScene)register({el:hero,update(){if(reduce.matches)return false;const p=clamp(-hero.getBoundingClientRect().top/innerHeight,-1,1);hero.style.setProperty('--seal-angle',`${-15+p*100}deg`);hero.style.setProperty('--hero-y',`${p*22}px`);return false;}});
  }
  function preference() {document.body.classList.toggle('j-motion-on',!reduce.matches);wake();}
  preference();init();reduce.addEventListener('change',preference);
  addEventListener('scroll',wake,{passive:true});addEventListener('resize',wake,{passive:true});
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{animated.forEach(scene=>{if(e.target.contains(scene.el)){animated.delete(scene);observer?.unobserve(scene.el);}});});
  document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(frame);frame=0;}else wake();});
})();
